import React, { useEffect } from 'react';
import GitTrails from '../../components/BtAdminPanel/GitAnalytics/GitTrails';
import { useAppDispatch, useAppSelector } from '../../hooks/storeHooks';
import { getAllUsers } from '../../store/slice/userSlice';
import IUserList from '../../utils/UserList/UserList.interface';

const Analytics = () => {
  const dispatch = useAppDispatch();
  const { data, status, error } = useAppSelector((state) => state.users);

  const getOrganizationList = (data: IUserList[] | null) => {
    if (data) {
      const orgs: Set<string> = new Set();
      data.forEach((item) => {
        orgs.add(item.companyName ?? '');
      });
      return Array.from(orgs)
        .filter((item) => item)
        .sort((a, b) => a.localeCompare(b));
    } else {
      return null;
    }
  };

  const organizations: string[] | null = getOrganizationList(data);
  const isLoading = !data && status === 'loading';

  useEffect(() => {
    if (status !== 'loading') {
      void dispatch(getAllUsers());
    }
  }, []);

  return (
    <GitTrails
      isLoading={isLoading}
      error={error ?? null}
      users={data}
      organizations={organizations}
    />
  );
};

export default Analytics;
